import { rage, useObservable } from '~/rage';
import battery from '../../assets/icons/battery.svg';
import mobile from '../../assets/icons/mobile.svg';
import wifi from '../../assets/icons/wifi.svg';
import { TextLabel } from '../TextLabel';
import {
	StyledContainer,
	StyledLeftContainer,
	StyledRightContainer,
} from './TabletTopRow.styled';

const TabletTopRow = () => {
	const realTime = useObservable(rage.game.getRealTime());

	return (
		<StyledContainer>
			<StyledLeftContainer>
				<TextLabel
					style={{ width: 32, fontSize: 12, fontWeight: 500, color: '#ffffff' }}
				>
					{realTime.time}
				</TextLabel>
				<TextLabel
					style={{
						fontSize: 12,
						fontWeight: 500,
						color: '#ffffff',
						opacity: 0.5,
					}}
				>
					<span style={{ textTransform: 'capitalize' }}>
						{realTime.weekdayShort}
					</span>
					. {realTime.dateShort}
				</TextLabel>
			</StyledLeftContainer>
			<StyledRightContainer>
				<img src={mobile} />
				<img src={wifi} />
				<img src={battery} />
			</StyledRightContainer>
		</StyledContainer>
	);
};

export { TabletTopRow };
